(function() {
  const tutorials = document.querySelectorAll('.product-tutorial');
  const modal = document.getElementById('tutorialModal');
  if (!modal) return;

  const modalTrack = document.getElementById('modalTrack');
  const overlay = modal.querySelector('.tutorial-modal__overlay');
  const closeBtn = modal.querySelector('.tutorial-modal__close');
  const prevBtn = modal.querySelector('.tutorial-modal__arrow--prev');
  const nextBtn = modal.querySelector('.tutorial-modal__arrow--next');
  const statusRegion = modal.querySelector('.tutorial-modal__status');
  
  let currentIndex = 0;
  let triggerElement = null;
  const videos = [];
  const slides = [];
  const focusableSelector = 'button:not([disabled]), iframe, [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function getEmbedUrl(videoId, autoplay = false) {
    const params = [
      'playsinline=1',
      'rel=0',
      'modestbranding=1',
      'controls=1',
      'showinfo=0',
      'iv_load_policy=3',
      'fs=0',
      'cc_load_policy=0',
      'enablejsapi=1'
    ];

    if (autoplay) {
      params.push('autoplay=1');
      params.push('mute=1');
    }

    return `https://www.youtube-nocookie.com/embed/${videoId}?${params.join('&')}`;
  }

  function pauseIframe(iframe) {
    iframe.contentWindow?.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
  }

  // Collect video data and build carousel
  tutorials.forEach((tutorial, i) => {
    const videoId = tutorial.dataset.youtubeId;
    const title = tutorial.querySelector('.product-tutorial__title')?.textContent || '';
    if (!videoId) return;
    videos.push({ videoId, title });
    
    // Create slide in carousel
    const slide = document.createElement('div');
    slide.className = 'tutorial-modal__slide';
    slide.setAttribute('data-index', i);
    slide.innerHTML = `
      <iframe
        src="${getEmbedUrl(videoId, false)}"
        title="Tutorial video: ${title}"
        frameborder="0"
        allow="autoplay; encrypted-media; picture-in-picture; web-share"
        allowfullscreen
        aria-label="Tutorial video: ${title}"
      ></iframe>
    `;
    // Click on inactive slide to navigate
    slide.addEventListener('click', (e) => {
      if (i !== currentIndex) {
        e.preventDefault();
        goToVideo(i);
      }
    });
    
    modalTrack.appendChild(slide);
    slides.push(slide);
  });

  function openModal(index, trigger) {
    triggerElement = trigger;
    currentIndex = index;
    modal.classList.add('is-active');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    updateCarousel(false);
    updateArrows();
    playCurrentVideo();
    announceVideo(index);
    setTimeout(() => closeBtn.focus(), 50);
  }

  function closeModal() {
    modal.classList.remove('is-active');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    pauseAllVideos();
    if (triggerElement) {
      triggerElement.focus();
      triggerElement = null;
    }
  }

  function pauseAllVideos() {
    slides.forEach(slide => {
      const iframe = slide.querySelector('iframe');
      if (iframe) pauseIframe(iframe);
    });
  }

  function playCurrentVideo() {
    pauseAllVideos();
    const currentSlide = slides[currentIndex];
    const iframe = currentSlide.querySelector('iframe');
    const video = videos[currentIndex];
    if (iframe && video) {
      iframe.src = getEmbedUrl(video.videoId, true);
    }
  }

  function updateCarousel(animate = true) {
    const offset = currentIndex * -100;
    if (!animate) {
      modalTrack.style.transition = 'none';
    }
    modalTrack.style.transform = `translateX(${offset}%)`;
    if (!animate) {
      // Force reflow then restore transition
      modalTrack.offsetHeight;
      modalTrack.style.transition = '';
    }
    
    slides.forEach((slide, i) => {
      slide.classList.toggle('is-active', i === currentIndex);
    });
  }

  function goToVideo(index) {
    if (index < 0 || index >= videos.length) return;
    currentIndex = index;
    updateCarousel();
    updateArrows();
    playCurrentVideo();
    announceVideo(index);
  }

  function announceVideo(index) {
    statusRegion.textContent = `Now playing: ${videos[index].title}`;
  }

  function updateArrows() {
    prevBtn.disabled = currentIndex === 0;
    nextBtn.disabled = currentIndex === videos.length - 1;
  }

  // Focus trap
  function trapFocus(e) {
    if (!modal.classList.contains('is-active')) return;
    
    const focusable = modal.querySelectorAll(focusableSelector);
    const firstFocusable = focusable[0];
    const lastFocusable = focusable[focusable.length - 1];

    if (e.key === 'Tab') {
      if (e.shiftKey && document.activeElement === firstFocusable) {
        e.preventDefault();
        lastFocusable.focus();
      } else if (!e.shiftKey && document.activeElement === lastFocusable) {
        e.preventDefault();
        firstFocusable.focus();
      }
    }
  }

  // Event listeners
  tutorials.forEach((tutorial) => {
    const playBtn = tutorial.querySelector('.product-tutorial__play');
    const index = parseInt(tutorial.dataset.index, 10);
    playBtn.addEventListener('click', () => openModal(index, playBtn));
  });

  overlay.addEventListener('click', closeModal);
  closeBtn.addEventListener('click', closeModal);
  prevBtn.addEventListener('click', () => goToVideo(currentIndex - 1));
  nextBtn.addEventListener('click', () => goToVideo(currentIndex + 1));

  document.addEventListener('keydown', (e) => {
    if (!modal.classList.contains('is-active')) return;
    if (e.key === 'Escape') closeModal();
    // Only navigate with arrows if not focused on video controls
    const isIframeFocused = document.activeElement.tagName === 'IFRAME';
    if (e.key === 'ArrowLeft' && !isIframeFocused) goToVideo(currentIndex - 1);
    if (e.key === 'ArrowRight' && !isIframeFocused) goToVideo(currentIndex + 1);
    trapFocus(e);
  });
})();
